<template>
  <div class="add-service-manage">
    <div class="search-warehouse">
      <el-checkbox v-model="hideClosed" @change="onHideClosedChange">隐藏已关闭</el-checkbox>
      <div class="add">
        <el-button class="btn-blue" @click="add">+新增</el-button>
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="addServiceMaintenanceList" style="width: 100%" 
      :row-class-name="tableRowClassName">
        <el-table-column 
          v-for="(item, index) in tableTitleList"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button :disabled="!scope.row.status" class="btn-text mod-btn" type="text" @click="mod(scope.row)">编辑</el-button>
            <el-button v-if="!scope.row.status" class="btn-text" type="text" @click="open(scope.row)">开启</el-button>
            <el-button v-else class="btn-text" type="text" @click="close(scope.row)">关闭</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增/编辑 -->
    <el-dialog
      :title="addServiceForm.id ? '编辑' : '新增'"
      top="26vh"
      :visible.sync="addServiceDialog"
      width="420px"
    >
      <div class="border"></div>
      <el-form
        ref="addServiceForm"
        :model="addServiceForm"
      >
        <el-form-item label="增值服务名称" prop="name">
          <el-input v-model="addServiceForm.name" class="white" placeholder="请输入增值服务名称"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeServiceDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveService('addServiceForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddServiceManage from "models/add-service-manage";
import AddServiceMaintenanceMixins from 'common/mixins/add-service'
import { modifyNetTitle } from "common/js/util";
export default {
  mixins: [AddServiceMaintenanceMixins],
  data() {
    return {
      hideClosed: true,
      addServiceMaintenanceList: [],
      tableTitleList: [
        {label: '序号', prop: 'sort'},
        {label: '增值服务名称', prop: 'name'},
        {label: '创建时间', prop: 'createTime'},
      ],
      addServiceDialog: false,
      addServiceForm: {
        id: '',
        name: ''
      }
    };
  },
  created() {
    modifyNetTitle('增值服务维护')
    this.fetchList();
  },
  methods: {
    fetchList() {
      const params = this.hideClosed ? { hideClosed: true } : {};
      this.initAddServiceList(params);
    },
    onHideClosedChange() {
      this.fetchList();
    },
    tableRowClassName({ row }) {
      if (!row.status) {
        return "close-row";
      }
    },
    //新增
    add() {
      this.addServiceDialog = true;
    },
    closeServiceDialog() {
      this.addServiceForm.name = ''
      this.addServiceDialog = false;
    },
    saveService(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.addServiceForm.id) {
            let data = {};
            data.id = this.addServiceForm.id;
            data.name = this.addServiceForm.name;
            AddServiceManage.postUpdateAddService(this.addServiceForm.id, data).then(res => {
              if (res.success) {
                this.fetchList();
                this.$message.success("修改成功");
                this.closeServiceDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.addServiceForm.name;
            AddServiceManage.postAddAddService(data).then(res => {
              if (res.success) {
                this.fetchList();
                this.$message.success("新增成功");
                this.closeServiceDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    mod(row) {
      this.addServiceForm.name = row.name
      this.addServiceForm.id = row.id
      this.add()
    },
    open(row) {
      this.$confirm("是否开启该增值服务？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      })
        .then(() => {
          this.commonFun(row)
        })
        .catch(() => {});
    },
    close(row) {
      this.$confirm("是否关闭该增值服务？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      })
        .then(() => {
          this.commonFun(row)
        })
        .catch(() => {});
    },

    commonFun(row) {
      AddServiceManage.postUpdateAddServiceStatus(row.id).then(res => {
        if (res.success) {
          this.fetchList();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.add-service-manage {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .search-warehouse {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;

    .el-checkbox {
      margin-right: 16px;
      .el-checkbox__label {
        padding-left: 4px;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        font-family: 'PingFang SC-Regular';
      }
      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #2E68EA;
        border-color: #2E68EA;
      }
      .el-checkbox__inner:hover {
        border-color: #2E68EA;
      }
      .el-checkbox__input.is-disabled .el-checkbox__inner::after {
        border-color: #fff;
      }
      .el-checkbox__input.is-disabled .el-checkbox__inner {
        background-color: #EBEEF5;
        border-color: #EBEEF5;
      }
    }
    .el-checkbox.is-checked .el-checkbox__label {
      color: #2E68EA;
    }
  }
  .table .el-table .el-table__body-wrapper .el-table__body .close-row td .cell {
    color: #999999;
    font-family: 'PingFang SC-Regular';
    .el-button.mod-btn {
      color: #999999;
      font-size: 14px;
    }
  }
  
  .el-dialog {
    .el-dialog__header {
      padding-left: 20px;
    }
    .el-dialog__body {
      padding: 0px;
      .el-form {
        padding: 20px;
        .el-form-item {
          .el-form-item__label {
            width: 100%;
            text-align: left;
          }
          .el-form-item__content {
            width: 100%;
          }
        }
      }
      .border {
        border-color: #EEEEEE;
        margin-bottom: 0px
      }
    }
    .dialog-footer {
      padding-bottom: 20px;
      border-top: 1px solid #f7f7f7;
      padding-top: 20px;
      display: flex;
      justify-content: center;
    }
  }
}
.el-message-box__wrapper {
  .el-message-box {
    padding-bottom: 20px;
    .el-message-box__header {
      padding: 12px 16px;
      border-bottom: 1px solid #eee;
      .el-message-box__title {
        color: #333333;
        line-height: 24px;
        font-size: 16px;
        font-family: 'PingFang SC-Regular';
        font-weight: 400;
      }
      .el-message-box__headerbtn {
        right: 30px;
        top: 20px;
      }
    }
    .el-message-box__content {
      padding: 25px 30px;
      border-bottom: 1px solid #eee;
    }
    .el-message-box__input {
      padding-top: 0px;
      height: 32px;
      .el-input {
        width: 100%;
      }
    }
    .el-message-box__btns {
      padding-top: 20px;
      padding-right: 30px;
      text-align: center;
      .el-button {
        font-size: 14px;
        font-family: 'PingFang SC-Regular';
        font-weight: 400;
        min-width: 60px;
      }
      .btn-blue {
        border: 1px solid #2E68EA;
        background: #2E68EA;
        color: white;
      }
      .btn-white {
        border: 1px solid #2E68EA;
        background: white;
        color: #2E68EA;
      }
    }
  }
}
</style>
